import React from 'react';
import { socialLinks } from '../../Utils/data';
import './Footer.css';

/**
 * The email, location and availability that used to clutter the hero live
 * here instead, which is where people look for them.
 */
function Footer({ personal }) {
  const { fullName, email, location, timezone } = personal;
  const year = new Date().getFullYear();

  return (
    <footer className="foot">
      <div className="shell foot__inner">

        <a href={`mailto:${email}`} className="foot__email">{email}</a>

        <div className="foot__cols">
          <div className="foot__col">
            <span className="foot__label">Elsewhere</span>
            <ul className="foot__list">
              <li><a href={socialLinks.github} target="_blank" rel="noreferrer">GitHub</a></li>
              <li><a href={socialLinks.linkedin} target="_blank" rel="noreferrer">LinkedIn</a></li>
              <li><a href={socialLinks.twitter} target="_blank" rel="noreferrer">Twitter</a></li>
            </ul>
          </div>

          <div className="foot__col">
            <span className="foot__label">Based in</span>
            <p className="foot__plain">{location}</p>
            <p className="foot__plain foot__plain--dim">{timezone}</p>
          </div>

          <div className="foot__col">
            <span className="foot__label">Résumé</span>
            <ul className="foot__list">
              <li><a href="/assets/cv/resume.pdf" target="_blank" rel="noreferrer">Download PDF</a></li>
            </ul>
          </div>
        </div>

        <div className="foot__base">
          <p>© {year} {fullName}</p>
          {/* <p>Built with Love</p> */}
        </div>

      </div>
    </footer>
  );
}

export default Footer;
